import React from 'react';
import { Button } from '@sbt-web/ui';

type Props = {
  onClick: () => void;
  label: string;
  className?: string;
};

const InfoBadge = ({ onClick, label, className }: Props) => {
  return (
    <Button
      design="text"
      size="small"
      onClick={onClick}
      icon={
        <img
          src="/static/img/ui/info.svg"
          height={16}
          width={16}
          alt=""
          loading="lazy"
          decoding="async"
        />
      }
      aria-label={`Più dettagli sui valori del filtro "${label}"`}
      classes={[className ?? '']}
    />
  );
};

export default InfoBadge;
